import { FloorGameCrypto, type NftTimelineEvent, NftTransaction } from '@pkg/types/floorGame';

import { type NftCardNoticeDescriptor, NftCardNotificationEvent, NftCardNotificationSuffix } from './types';

export const valueThreshhold = {
    [FloorGameCrypto.Ethereum]: {
        [NftCardNotificationSuffix.Curse]: 0.3,
        [NftCardNotificationSuffix.Explode]: 8,
    },
};

export const suffixEmoji = {
    [NftCardNotificationSuffix.Curse]: '🤬',
    [NftCardNotificationSuffix.Explode]: '🤯',
};

interface SuffixCriteria {
    currency?: FloorGameCrypto;
    price?: number;
}

export function getSuffix({ currency, price = 0 }: SuffixCriteria) {
    // TODO: Eventually support multiple currencies.
    if (currency !== FloorGameCrypto.Ethereum) return undefined;

    const threshold = valueThreshhold[currency];

    if (price <= threshold[NftCardNotificationSuffix.Curse]) {
        return suffixEmoji[NftCardNotificationSuffix.Curse];
    }

    if (price >= threshold[NftCardNotificationSuffix.Explode]) {
        return suffixEmoji[NftCardNotificationSuffix.Explode];
    }

    return undefined;
}

export function transactionToNotificationEvent(transaction: NftTransaction) {
    if (transaction === NftTransaction.Burn) {
        return NftCardNotificationEvent.Burned;
    }

    if (transaction === NftTransaction.Sale) {
        return NftCardNotificationEvent.Sold;
    }

    if (transaction === NftTransaction.List) {
        return NftCardNotificationEvent.Listed;
    }

    // TODO: Redundant return. Still waiting to clarify this function.
    return NftCardNotificationEvent.Listed;
}

export function timelineEventToNotification({ type, asset, value }: NftTimelineEvent): NftCardNoticeDescriptor {
    return {
        // This `id` needs to match the `timeline.event.asset.id`
        // in order for the "past notices" state comparison to work.
        id: asset.id,
        event: transactionToNotificationEvent(type),
        name: asset.name,
        thumbnail: asset.thumbnail,
        currency: value.currency,
        price: value.price,
    };
}
